export const idolSelectData = {
	"idols":[

		"chiyo",
		"kana",
		"aqua",
		"izumi",
		"aika",
		"hua",
		"erity",
		"rui",
		"rei"

	],
	"image":"idol_sprites_small.png",
	"width":1760,
	"height":404

}